import { render, staticRenderFns } from "./RmpAlert.vue?vue&type=template&id=652dd0f3&scoped=true"
import script from "./RmpAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpAlert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652dd0f3",
  null
  
)

export default component.exports